

export const EmptyGroupChannelListIndicator = () => (
    <div className="team-empty-channel-list-indicator">There are no group channels. Start by creating some.</div>
);
export const EmptyDMChannelListIndicator = () => (
    <div className="team-empty-channel-list-indicator">There are no DM channels. Start by creating some.</div>
);